import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";
import { SENTRY_RELEASE } from './environments/release';

Sentry.init({
  dsn: "https://861400b93bfdc7a9a32a064ce32d0001@o1217314.ingest.us.sentry.io/4510414600404992",
  release: SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/playble\.drabba\.org/, /^https:\/\/playble\.me/, /^https:\/\/playbletest\.azapp.org/, /^\//],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});



bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
